/**
 * BLENMY&CO. custom: PDPメディアギャラリーの切替を即時化する拡張。
 * テーマ本体のJSは書き換えず、公開APIのラップとイベント購読のみで実装する
 * （Horizonテーマ更新時に消えない・衝突しない）。
 *
 * 1) media-gallery 内の slideshow の select を常に animate:false で実行
 *    → scrolling.js が behavior:'instant' でスクロールし、サムネイル/矢印/
 *      ドットによる切替が即時になる（prefers-reduced-motion と同じコードパス）
 * 2) カラー（バリアント）選択の瞬間に、該当カラーの画像スライドへ先回りでジャンプ
 *    → Horizon標準はサーバー再レンダリング完了までギャラリーが変わらないため、
 *      手元のスライドから対象画像を探して楽観的に切り替え、体感ラグをなくす。
 *      サーバー応答後の差し替え（選択バリアント画像が先頭に並ぶ）と結果は一致する。
 */

// (1) ギャラリー内スライドショーの即時切替
customElements.whenDefined('slideshow-component').then(() => {
  const Slideshow = customElements.get('slideshow-component');
  if (!Slideshow || typeof Slideshow.prototype.select !== 'function') return;
  const originalSelect = Slideshow.prototype.select;
  Slideshow.prototype.select = function (index, event, options = {}) {
    if (this.closest('media-gallery')) {
      options = { ...options, animate: false };
    }
    return originalSelect.call(this, index, event, options);
  };
});

// (2) バリアント選択時の楽観的スライドジャンプ
(() => {
  const productCache = new Map();

  const fileNameOf = (url) => {
    if (!url) return null;
    try {
      return new URL(url, window.location.origin).pathname.split('/').pop();
    } catch (error) {
      return null;
    }
  };

  document.addEventListener('shopify:product:select', async (event) => {
    // event.detail はフラット構造: { optionValueId, variantId, connectedProductUrl }
    const variantId = Number(event.detail?.variantId);
    if (!variantId) return;

    const picker = event.target instanceof Element ? event.target : null;
    const handle =
      picker?.dataset?.productHandle ||
      window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
    if (!handle) return;
    const section = picker?.closest('.shopify-section, dialog');
    const slideshow = section?.querySelector('media-gallery slideshow-component');
    if (!slideshow || typeof slideshow.select !== 'function') return;

    let product = productCache.get(handle);
    if (!product) {
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) return;
        product = await response.json();
        productCache.set(handle, product);
      } catch (error) {
        return;
      }
    }

    const variant = product.variants?.find((v) => v.id === variantId);
    // featured_image が無いバリアントは元の先頭メディア＝そのバリアントの画像
    // （サーバー側 sorted_media と同じ規則）
    const targetSrc = variant?.featured_image?.src || product.media?.[0]?.src;
    const targetFile = fileNameOf(targetSrc);
    if (!targetFile) return;

    const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
    const targetIndex = slides.findIndex((slide) => {
      const img = slide.querySelector('img');
      return img && fileNameOf(img.currentSrc || img.src) === targetFile;
    });

    if (targetIndex >= 0) {
      slideshow.select(targetIndex);
    }
  });
})();
